import { lazy } from "react";

const lazyPage = (importer, exportName) =>
    lazy(() =>
        importer().then((module) => ({
            default: exportName ? module[exportName] : module.default,
        }))
    );

const Home = lazyPage(() => import("./Pages/Home/index"), "Home");
const BoardOfDirectors = lazyPage(() => import("./Pages/About/BoardOfDirectors/BoardOfDirectors"), "BoardOfDirectors");
const CEOMsg = lazyPage(() => import("./Pages/About/CEOMsg/CEOMsg"), "CEOMsg");
const SpecializedCommittee = lazyPage(() => import("./Pages/About/SpecializedCommittee/SpecializedCommittee"), "SpecializedCommittee");
const IrenexStatute = lazyPage(() => import("./Pages/About/IrenexStatute"), "IrenexStatute");
const CorporateGovernance = lazyPage(() => import("./Pages/About/CorporateGovernance"), "CorporateGovernance");
const SocialResponsibility = lazyPage(() => import("./Pages/About/SocialResponsibility"), "SocialResponsibility");
const SustainabilityReport = lazyPage(() => import("./Pages/About/SustainabilityReport/SustainabilityReport"), "SustainabilityReport");
const ExecutiveManagers = lazyPage(() => import("./Pages/About/Managers/ExecutiveManagers"), "ExecutiveManagers");
const OrganizationChart = lazyPage(() => import("./Pages/About/OrganizationChart"), "OrganizationChart");
const TradeFees = lazyPage(() => import("./Pages/About/TradeFees/TradeFees"), "TradeFees");
const Encyclopedia = lazyPage(() => import("./Pages/Encyclopedia/Encyclopedia"), "Encyclopedia");
const LetterList = lazyPage(() => import("./Pages/Encyclopedia/LetterList"), "LetterList");
const AcceptedProduct = lazyPage(() => import("./Pages/Encyclopedia/AcceptedProduct"), "AcceptedProduct");
const IrenexAtGlance = lazyPage(() => import("./Pages/About/IrenexAtGlance/IrenexAtGlance"), "IrenexAtGlance");
const ContactUs = lazyPage(() => import("./Pages/About/ContactUs/ContactUs"), "ContactUs");
const Analyze = lazyPage(() => import("./Pages/Analyze/Analyze"), "Analyze");
const AheadAuctions = lazyPage(() => import("./Pages/Markets/AheadAuctions"), "AheadAuctions");
const Forms = lazyPage(() => import("./Pages/Forms/Forms"), "Forms");
const Announcements = lazyPage(() => import("./Pages/Announcements/Announcements"), "Announcements");
const AllAnnouncements = lazyPage(() => import("./Pages/Announcements/AllAnnouncements"), "AllAnnouncements");
const Search = lazyPage(() => import("./Pages/Search/Search"), "Search");
const PDFReader = lazyPage(() => import("./Components/PDF/PDFReader"), "PDFReader");
const AuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/AuctionDetail"), "AuctionDetail");
const PowerAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/PowerAuctionDetail"), "PowerAuctionDetail");
const FutureAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/FutureAuctionDetail"), "FutureAuctionDetail");
const DerivativeAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/DerivativeAuctionDetail"), "DerivativeAuctionDetail");
const ParallelSalafAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/ParallelSalafAuctionDetail"), "ParallelSalafAuctionDetail");
const ProjectInvestmentFundAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/ProjectInvestmentFundAuctionDetail"), "ProjectInvestmentFundAuctionDetail");
const DepositCertificateAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/DepositCertificateAuctionDetail"), "DepositCertificateAuctionDetail");
const CapactiyCertificatAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/CapactiyCertificatAuctionDetail"), "CapactiyCertificatAuctionDetail");
const EnergySavingCertificateAuctionDetail = lazyPage(() => import("./Pages/Markets/Auctions/EnergySavingCertificateAuctionDetail"), "EnergySavingCertificateAuctionDetail");
const MarketMakers = lazyPage(() => import("./Pages/Markets/MarketMakers/MarketMakers"));
const OffersAnnouncementDetail = lazyPage(() => import("./Pages/Markets/PhysicalMarket/OffersAnnouncementDetail/OffersAnnouncementDetail"), "OffersAnnouncementDetail");
const MarketTabs = lazyPage(() => import("./Pages/Markets/MarketTabs"), "MarketTabs");
const PowerOffersAnnouncementDetail = lazyPage(() => import("./Pages/Markets/PowerMarket/OffersAnnouncementDetail/PowerOffersAnnouncementDetail"), "PowerOffersAnnouncementDetail");
const Report = lazyPage(() => import("./Pages/Markets/Report/Report"), "Report");
const ProspectusTabs = lazyPage(() => import("./Pages/Listing/Prospectus/ProspectusTabs"), "ProspectusTabs");
const Brokers = lazyPage(() => import("./Pages/ValueChain/Brokers/Brokers"), "Brokers");
const Instruments = lazyPage(() => import("./Pages/Listing/Instruments/Instruments"), "Instruments");
const ListingIntroduction = lazyPage(() => import("./Pages/Listing/ListingIntroduction/ListingIntroduction"), "ListingIntroduction");
const SupplyStatementsList = lazyPage(() => import("./Pages/Listing/SupplyStatementsList"), "SupplyStatementsList");
const Inventories = lazyPage(() => import("./Pages/Listing/Inventories/Inventories"), "Inventories");
const RankingOfAdmissionsCounselors = lazyPage(() => import("./Pages/Listing/RankingOfAdmissionsCounselors/RankingOfAdmissionsCounselors"), "RankingOfAdmissionsCounselors");
const Producers = lazyPage(() => import("./Pages/ValueChain/Producers/Producers"), "Producers");
const ProducerStatistics = lazyPage(() => import("./Pages/ValueChain/Producers/Statistics/ProducerStatistics"), "ProducerStatistics");
const ProducerAnnouncements = lazyPage(() => import("./Pages/ValueChain/Producers/Announcements/ProducerAnnouncements"), "ProducerAnnouncements");
const Companies = lazyPage(() => import("./Pages/ValueChain/Producers/Companies/Companies"), "Companies");
const Commodities = lazyPage(() => import("./Pages/ValueChain/Commodities/Commodities"), "Commodities");
const CommodityStatistics = lazyPage(() => import("./Pages/ValueChain/Commodities/Statistics/CommodityStatistics"), "CommodityStatistics");
const GetCommodity = lazyPage(() => import("./Pages/ValueChain/Commodities/Commodity/GetCommodity"), "GetCommodity");
const CalendarPage = lazyPage(() => import("./Pages/ValueChain/Calendar/CalendarPage"), "CalendarPage");
const NewsItem = lazyPage(() => import("./Pages/Media/News/NewsItem"), "NewsItem");
const News = lazyPage(() => import("./Pages/Media/News/News"), "News");
const Archive = lazyPage(() => import("./Pages/Media/News/Archive"), "Archive");
const BourseEnergy = lazyPage(() => import("./Pages/Media/News/BourseEnergy/BourseEnergy"), "BourseEnergy");
const WorldEnergy = lazyPage(() => import("./Pages/Media/News/WorldEnergy/WorldEnergy"), "WorldEnergy");
const DataView = lazyPage(() => import("./Pages/Media/DataView/DataView"), "DataView");
const DataViewItem = lazyPage(() => import("./Pages/Media/DataView/DataViewItem"), "DataViewItem");
const ArticlesList = lazyPage(() => import("./Pages/Media/Articles/ArticlesList"), "ArticlesList");
const ArticlesItem = lazyPage(() => import("./Pages/Media/Articles/ArticlesItem"), "ArticlesItem");
const Multimedia = lazyPage(() => import("./Pages/Media/Multimedia/Multimedia"), "Multimedia");
const MultimediaItem = lazyPage(() => import("./Pages/Media/Multimedia/MultimediaItem"), "MultimediaItem");
const VideoArchive = lazyPage(() => import("./Pages/Media/Multimedia/Video/VideoArchive"), "VideoArchive");
const VideoItem = lazyPage(() => import("./Pages/Media/Multimedia/Video/VideoItem"), "VideoItem");
const OtherContentArchive = lazyPage(() => import("./Pages/Media/Multimedia/OtherContent/OtherContentArchive"), "OtherContentArchive");
const InfographicArchive = lazyPage(() => import("./Pages/Media/Multimedia/Infographic/InfographicArchive"), "InfographicArchive");
const InfographicItem = lazyPage(() => import("./Pages/Media/Multimedia/Infographic/InfographicItem"), "InfographicItem");
const BookletArchive = lazyPage(() => import("./Pages/Media/Multimedia/Booklet/BookletArchive"), "BookletArchive");
const BookletItem = lazyPage(() => import("./Pages/Media/Multimedia/Booklet/BookletItem"), "BookletItem");
const VisualReportsList = lazyPage(() => import("./Pages/Media/VisualReports/VisualReportsList"), "VisualReportsList");
const VisualReportsItem = lazyPage(() => import("./Pages/Media/VisualReports/VisualReportsItem"), "VisualReportsItem");
const RulesList = lazyPage(() => import("./Pages/Rules/RulesList"), "RulesList");
const ResearchReportsList = lazyPage(() => import("./Pages/MarketExpansion/ResearchReportsList"), "ResearchReportsList");
const ResearchPrioritiesList = lazyPage(() => import("./Pages/MarketExpansion/ResearchPrioritiesList"), "ResearchPrioritiesList");
const PowerCalculator = lazyPage(() => import("./Pages/Markets/PowerMarket/PowerCalculator/PowerCalculator"));
const LegalLiteracy = lazyPage(() => import("./Pages/LegalLiteracy/LegalLiteracy"));
const LegalLiteracyItem = lazyPage(() => import("./Pages/LegalLiteracy/LegalLiteracyItem"));
const QrCode = lazyPage(() => import("./Pages/QrCode/QrCode"));

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/QrCode',
        element: <QrCode />
    },
    {
        path: '/Search',
        element: <Search />
    },
    {
        path: '/BoardOfDirectors',
        element: <BoardOfDirectors />
    },
    {
        path: '/CEOMessage',
        element: <CEOMsg />
    },
    {
        path: '/SpecializedCommittee',
        element: <SpecializedCommittee />
    },
    {
        path: '/Encyclopedia',
        element: <Encyclopedia />
    },
    {
        path: '/Encyclopedia/:letter/all',
        element: <LetterList />
    },
    {
        path: '/Encyclopedia/:letter/:commodityName/:id',
        element: <AcceptedProduct />
    },
    {
        path: '/IrenexStatute',
        element: <IrenexStatute />
    },
    {
        path: '/SustainabilityReport',
        element: <SustainabilityReport />
    },
    {
        path: '/SocialResponsibility',
        element: <SocialResponsibility />
    },
    {
        path: '/CorporateGovernance',
        element: <CorporateGovernance />
    },
    {
        path: '/Listing/ListingIntroduction',
        element: <ListingIntroduction />
    },
    {
        path: '/Listing/RankingOfListingConsultants',
        element: <RankingOfAdmissionsCounselors />
    },
    {
        path: '/Listing/RankingOfListingConsultants/:tab',
        element: <RankingOfAdmissionsCounselors />
    },
    {
        path: '/Listing/SupplyStatementsList',
        element: <SupplyStatementsList />
    }
    ,
    {
        path: '/Listing/Inventories/:tab',
        element: <Inventories />
    },
    {
        path: '/Listing/Producers',
        element: <Producers />
    },
    {
        path: '/Listing/Producers/:id',
        element: <Companies />
    },
    {
        path: '/Listing/Producers/:id/Statistics',
        element: <ProducerStatistics />
    },
    {
        path: '/Listing/Producers/:id/Announcements',
        element: <ProducerAnnouncements />
    },
    {
        path: '/Listing/Commodities',
        element: <Commodities />
    },
    {
        path: '/Calendar',
        element: <CalendarPage />
    },
    {
        path: '/Listing/Commodities/:id',
        element: <GetCommodity />
    },
    {
        path: '/Listing/Commodities/:id/Statistics',
        element: <CommodityStatistics />
    },
    {
        path: '/ExecutiveManagers',
        element: <ExecutiveManagers />
    },
    {
        path: '/OrganizationChart',
        element: <OrganizationChart />
    },
    {
        path: '/TradesFee',
        element: <TradeFees />
    },
    {
        path: '/IrenexAtGlance',
        element: <IrenexAtGlance />
    },
    {
        path: '/ContactUs',
        element: <ContactUs />
    },
    {
        path: '/Analyze/Products',
        element: <Analyze />
    },
    {
        path: '/Analyze/Producers',
        element: <Analyze />
    },
    {
        path: '/Analyze/Products/:productSubTypeId/:id',
        element: <Analyze />
    },
    {
        path: '/Analyze/Producers/:id',
        element: <Analyze />
    },
    {
        path: '/AheadAuctions',
        element: <AheadAuctions />
    },
    {
        path: '/Market/Brokers',
        element: <Brokers />
    },
    {
        path: '/Listing/Instruments',
        element: <Instruments />
    },
    {
        path: '/Forms',
        element: <Forms />
    },
    {
        path: '/Announcements',
        element: <Announcements />
    },
    {
        path: '/Announcements/AllAnnouncements',
        element: <AllAnnouncements />
    },
    {
        path: '/Announcements/AllAnnouncements/:id',
        element: <AllAnnouncements />
    },
    {
        path: '/MarketExpansion/ResearchReportsList',
        element: <ResearchReportsList />
    },
    {
        path: '/MarketExpansion/ResearchPrioritiesList',
        element: <ResearchPrioritiesList />
    },
    {
        path: '/PDFPreview/:id',
        element: <PDFReader />
    },
    {
        path: '/Media/DataView',
        element: <DataView />
    },
    {
        path: "Media/DataView/Post/:id",
        element: <DataViewItem />
    },
    {
        path: '/Media/News',
        element: <News />
    },
    {
        path: '/Media/News/All',
        element: <Archive />
    },
    {
        path: '/Media/News/:Name',
        element: <News />
    },
    {
        path: '/Media/News/BourseEnergy',
        element: <BourseEnergy />
    },
    {
        path: '/Media/News/WorldEnergy',
        element: <WorldEnergy />
    },
    {
        path: "/Media/News/Post/:id",
        element: <NewsItem />
    },
    {
        path: '/Media/Articles',
        element: <ArticlesList />
    },
    {
        path: "/Media/Articles/Post/:id",
        element: <ArticlesItem />
    },
    {
        path: '/Media/Multimedia',
        element: <Multimedia />
    },
    {
        path: "/Media/Multimedia/Post/:id",
        element: <MultimediaItem />
    },
    {
        path: "/Media/Multimedia/Booklet/:id",
        element: <BookletItem />
    },

    {
        path: '/Media/Multimedia/Video',
        element: <VideoArchive />
    },
    {
        path: "/Media/Multimedia/Video/:id",
        element: <VideoItem />
    },
    {
        path: '/Media/Multimedia/Booklet',
        element: <BookletArchive />
    },
    {
        path: '/Media/Multimedia/Infographic',
        element: <InfographicArchive />
    },
    {
        path: "/Media/Multimedia/Infographic/:id",
        element: <InfographicItem />
    },
    {
        path: '/Media/Multimedia/OtherContent',
        element: <OtherContentArchive />
    },
    {
        path: '/Media/VisualReports',
        element: <VisualReportsList />
    },
    {
        path: "/Media/VisualReports/Post/:id",
        element: <VisualReportsItem />
    },
    {
        path: '/Markets/PhysicalMarket/Auction/:auctionIdn',
        element: <AuctionDetail />
    },
    {
        path: '/Markets/PowerMarket/Auction/:auctionIdn',
        element: <PowerAuctionDetail />
    },
    {
        path: '/Markets/Future/Auction/:insCode',
        element: <FutureAuctionDetail />
    },
    {
        path: '/Markets/DerivativeMarket/Auction/:insCode',
        element: <DerivativeAuctionDetail />
    },
    {
        path: '/Markets/ProjectInvestmentFund/Auction/:insCode',
        element: <ProjectInvestmentFundAuctionDetail />
    },
    {
        path: '/Markets/ParallelSalaf/Auction/:insCode',
        element: <ParallelSalafAuctionDetail />
    },
    {
        path: '/Markets/DepositCertificate/Auction/:insCode',
        element: <DepositCertificateAuctionDetail />
    },
    {
        path: '/Markets/EnergySavingCertificate/Auction/:insCode',
        element: <EnergySavingCertificateAuctionDetail />
    },
    {
        path: '/Markets/CapactiyCertificate/Auction/:insCode',
        element: <CapactiyCertificatAuctionDetail />
    },
    {
        path: "/Market/:mainTab/:subTab",
        element: <MarketTabs />
    },
    {
        path: "/Listing/Prospectus/:mainTab/:subTab",
        element: <ProspectusTabs />
    },
    {
        path: '/PhysicalMarket/OffersAnnouncements/Auction/:auctionIdn',
        element: <OffersAnnouncementDetail />
    },
    {
        path: '/PowerMarket/OffersAnnouncements/Auction/:auctionIdn',
        element: <PowerOffersAnnouncementDetail />
    },
    {
        path: '/Rules',
        element: <RulesList />
    },
    {
        path: '/Market/MarketMakers',
        element: <MarketMakers />
    },
    {
        path: "/Market/Report/:period",
        element: <Report />
    },
    {
        path: '/Markets/PowerMarket/PowerCalculator',
        element: <PowerCalculator />
    },
    {
        path: '/LegalLiteracy',
        element: <LegalLiteracy />
    },
    {
        path: "/LegalLiteracy/:id",
        element: <LegalLiteracyItem />
    },
];

export default AppRoutes;
